"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const components_1 = require("components");
const utils_1 = require("utils");
function AccountNumber({ accountNumberString, fontVariant = 'body-large', }) {
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [formattedNumber, setFormattedNumber] = (0, react_1.useState)((0, utils_1.maskNumber)(accountNumberString));
    const handleVisibility = () => {
        setVisible(!visible);
        setFormattedNumber(!visible ? accountNumberString : (0, utils_1.maskNumber)(accountNumberString));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "account-number", children: [(0, jsx_runtime_1.jsx)(components_1.P, { variant: fontVariant, className: "number", children: formattedNumber }), (0, jsx_runtime_1.jsx)(lp_components_1.Button, { type: "button", onClick: handleVisibility, className: "account-number__visibility-button", children: !visible ? (0, jsx_runtime_1.jsx)(Visibility_1.default, {}) : (0, jsx_runtime_1.jsx)(VisibilityOff_1.default, {}) })] }));
}
exports.default = (0, react_1.memo)(AccountNumber);
